var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.id,"title":_vm.$t('size-cm-conversion-table.title'),"centered":""},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var close = ref.close;
return [_c('b-button',{staticClass:"w-100",attrs:{"variant":"default"},on:{"click":function($event){return close()}}},[_vm._v(_vm._s(_vm.$t('modal.button.close.label')))])]}}])},[_c('size-cm-conversion-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }